/** Product Hunt's upvote triangle, used as the offer's only brand mark. */
export function ProductHuntMark({ className = 'h-2.5 w-2.5' }: { className?: string }) {
    return (
        <svg viewBox="0 0 10 9" className={className} aria-hidden="true">
            <path d="M5 0l5 9H0z" fill="#FF6154" />
        </svg>
    )
}

interface TrialTimelineProps {
    /** Trial length in days. */
    total: number
    /** Days still left to claim the offer. */
    left: number
    /** Draw the discounted first period after the trial days. */
    paid?: boolean
    /** `onDark` for the navy strips, `onLight` for cards. */
    tone?: 'onDark' | 'onLight'
    className?: string
}

/**
 * The trial as a row of day cells: used days are faint, days still left are
 * solid and run straight into the first paid period, which is the promise of
 * the offer (paying early loses no trial days). Decorative only; callers say
 * the same thing in text.
 */
export function TrialTimeline({ total, left, paid = false, tone = 'onLight', className = '' }: TrialTimelineProps) {
    const used = Math.max(0, total - left)
    const cell = tone === 'onDark'
        ? (on: boolean) => (on ? 'bg-white' : 'bg-white/20')
        : (on: boolean) => (on ? 'bg-primary-400 dark:bg-primary-400' : 'bg-gray-200 dark:bg-gray-700')
    return (
        <div aria-hidden="true" className={`flex items-center gap-[3px] ${className}`}>
            {Array.from({ length: total }, (_, i) => (
                <span key={i} className={`h-full flex-1 rounded-[2px] ${cell(i >= used)}`} />
            ))}
            {paid && (
                <span className={`h-full flex-[6] rounded-[2px] ${tone === 'onDark' ? 'bg-primary-400' : 'bg-primary-600 dark:bg-primary-500'}`} />
            )}
        </div>
    )
}
